import { render, staticRenderFns } from "./RolesComponent.vue?vue&type=template&id=1a27f5a4&scoped=true"
import script from "./RolesComponent.vue?vue&type=script&lang=js"
export * from "./RolesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27f5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a27f5a4')) {
      api.createRecord('1a27f5a4', component.options)
    } else {
      api.reload('1a27f5a4', component.options)
    }
    module.hot.accept("./RolesComponent.vue?vue&type=template&id=1a27f5a4&scoped=true", function () {
      api.rerender('1a27f5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/profile/components/RolesComponent.vue"
export default component.exports